import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import get from 'lodash/get';
import values from 'lodash/values';
import uniqueId from 'lodash/uniqueId';
import MediaQuery from 'react-responsive';
import OfferMain from './OfferMain';
import OfferDetails from './OfferDetails';
import OfferDocuments from './OfferDocuments';
import BackArrow from '../Button/BackArrow';
import RoutedHeader from '../Header';
import HtmlParser from './HtmlParser';
import { LAYOUT, MIN_WIDTH } from '../Layout/enums';
import { offeringCategory } from '../../helpers/mappings';

import './index.css';
import {
  fetchOfferings,
  fetchOffering,
  fetchOfferingDocuments,
} from '../../actions';

import loadGif from '../../assets/images/loading.gif';

const testStats = [
  {
    text: '10%',
    description: 'Industry Growth Rate',
    toolTip: 'Industry growth rates can be used as a point of comparison for firms seeking to gauge their performance relative to their peers.',
  },
  {
    text: '15%',
    description: 'Specific Market Growth Rate',
    toolTip: 'Market Growth rate is defined as the rise in sales or market size within a given customer base over a specific period of time.',
  },
]; // TODO: use highlighted stats from backend

const offerMenu = ['Details', 'Description', 'Documents'];

const OfferDescription = ({ offering }) => {
  let { description } = offering;
  while (description.includes('{{IMAGE_SOURCE="')) {
    const indexOf = description.indexOf('{{IMAGE_SOURCE="');
    let url = description.substring(indexOf + '{{IMAGE_SOURCE="'.length);
    url = url.substring(0, url.indexOf('"'));
    const partly = `{{IMAGE_SOURCE="${url}"`;
    let postUrlPart = description.substring(description.indexOf(partly) + partly.length);
    postUrlPart = postUrlPart.substring(0, postUrlPart.indexOf('}}'));
    description = description.replace(
      `{{IMAGE_SOURCE="${url}"${postUrlPart}}}`,
      `<img src="${url}"${postUrlPart}/>`,
    );
  }
  while (description.includes('{{IMAGE_SOURCE_MOBILE="')) {
    const indexOf = description.indexOf('{{IMAGE_SOURCE_MOBILE="');
    let url = description.substring(indexOf + '{{IMAGE_SOURCE_MOBILE="'.length);
    url = url.substring(0, url.indexOf('"'));
    const partly = `{{IMAGE_SOURCE_MOBILE="${url}"`;
    let postUrlPart = description.substring(description.indexOf(partly) + partly.length);
    postUrlPart = postUrlPart.substring(0, postUrlPart.indexOf('}}'));
    description = description.replace(
      `{{IMAGE_SOURCE_MOBILE="${url}"${postUrlPart}}}`,
      '',
    );
  }

  return (
    <div styleName="offerDescription">
      <HtmlParser htmlString={description} />
    </div>
  );
};

const LoadOrMissing = ({ isOfferingsLoading }) => (
  isOfferingsLoading ?
    <img styleName="loadingGif" src={loadGif} alt="Loading" /> :
    <div styleName="notFound">Offer Not Found</div>
);


const OfferDisclaimer = ({ offering }) => (
  <div styleName="offerDisclaimer">
    <HtmlParser htmlString={offering.disclaimer} />
  </div>
);


// TODO: Offering documents from backend
class Offering extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedMenu: 0,
      offer: {},
    };
  }

  async componentWillMount() {
    const offering = await this.props.fetchOffering(this.props.offerId);
    this.setState({ offer: offering });
  }

  async componentDidMount() {
    this.props.fetchOfferings();
    this.props.fetchOfferingDocuments(this.props.offerId);
  }
  offerMenu = (selectedMenu, layout) => {
    let styleSuff = '';
    switch (layout) {
      case LAYOUT.TAB:
        styleSuff = 'Tab';
        break;
      case LAYOUT.MOB:
        styleSuff = 'Mob';
        break;
      // no default
    }

    return (
      <div id="offerMenu" styleName="offerMenu">
        {offerMenu.map((item, index) => {
          const itemId = uniqueId();
          return (
            <input
              id={item}
              type="button"
              key={itemId}
              styleName={index === selectedMenu ? `menuActive${styleSuff}` : `menuInactive${styleSuff}`}
              onClick={() => this.setState({
                ...this.state,
                selectedMenu: index,
              })}
              value={item}
            />);
        })}
      </div>
    );
  }
  render() {
    const {
      isOfferingsLoading,
      offerId,
      documents,
      mediaQueryValues,
      postCloseInvestmentsAllowedIn,
    } = this.props;
    const { selectedMenu } = this.state;
    const offering = this.props.offerings.filter(ofr =>
      (ofr.id === offerId))[0] || this.props.offerings.filter(ofr =>
        (ofr.shortUrlRoute === offerId))[0] || null;
    let SelectedMenuComp = null;
    switch (selectedMenu) {
      case 0:
        SelectedMenuComp = OfferDetails;
        break;
      case 1:
        SelectedMenuComp = OfferDescription;
        break;
      case 2:
        SelectedMenuComp = OfferDocuments;
        break;
      // no default
    }
    const offerCategory = (offering && offering.category) ? offering.category : 0;
    const propsToPassToChild = {
      offering: {
        ...offering,
        categoryName: values(offeringCategory).find(item => item.value === offerCategory).label,
      },
      documents,
    };
    return (
      <div>
        <RoutedHeader />
        <div styleName="offerFull">
          <div styleName="offerContainer">
            <div styleName="backArrow" >
              <BackArrow to="/offers" label="All Offers" />
            </div>
            {!isOfferingsLoading && offering && Object.keys(this.state.offer).length > 0 ?
              <div styleName="offerBody">
                <MediaQuery
                  minWidth={MIN_WIDTH.DESK}
                  values={mediaQueryValues}
                >
                  <OfferMain offering={this.state.offer} testStats={testStats} layout={LAYOUT.DESK} postCloseInvestmentsAllowedIn={postCloseInvestmentsAllowedIn} />
                  {this.offerMenu(selectedMenu, LAYOUT.DESK)}
                  <SelectedMenuComp
                    id="menuComp"
                    {...propsToPassToChild}
                    testStats={testStats}
                    layout={LAYOUT.DESK}
                  />
                </MediaQuery>
                <MediaQuery
                  minWidth={MIN_WIDTH.TAB}
                  maxWidth={MIN_WIDTH.DESK - 1}
                  values={mediaQueryValues}
                >
                  <OfferMain offering={this.state.offer} testStats={testStats} layout={LAYOUT.TAB} postCloseInvestmentsAllowedIn={postCloseInvestmentsAllowedIn} />
                  {this.offerMenu(selectedMenu, LAYOUT.TAB)}
                  <SelectedMenuComp
                    {...propsToPassToChild}
                    testStats={testStats}
                    layout={LAYOUT.TAB}
                  />
                </MediaQuery>
                <MediaQuery
                  maxWidth={MIN_WIDTH.TAB - 1}
                  values={mediaQueryValues}
                >
                  <OfferMain offering={this.state.offer} testStats={testStats} layout={LAYOUT.MOB} postCloseInvestmentsAllowedIn={postCloseInvestmentsAllowedIn} />
                  {this.offerMenu(selectedMenu, LAYOUT.MOB)}
                  <SelectedMenuComp
                    {...propsToPassToChild}
                    layout={LAYOUT.MOB}
                  />
                </MediaQuery>

                <OfferDisclaimer offering={offering} />
              </div>
              : <LoadOrMissing isOfferingsLoading={isOfferingsLoading || Object.keys(this.state.offer).length === 0} />}
          </div>
        </div>
      </div>
    );
  }
}

Offering.propTypes = {
  mediaQueryValues: PropTypes.shape({}),
};
Offering.defaultProps = {
  mediaQueryValues: {},
};


const mapStateToProps = (state, { match: { params: { offerId } } }) => ({
  offerings: get(state, 'offerings.data', []),
  documents: get(state, `offeringDocumentsByOffer.data.${offerId}`, {}),
  isOfferingsLoading: get(state, 'offerings.isFetching', false),
  offerId,
  postCloseInvestmentsAllowedIn: get(state, 'user.data.postCloseInvestmentsAllowedIn', []),
});

const mapDispatchToProps = {
  fetchOfferings,
  fetchOffering,
  fetchOfferingDocuments,
};

export default connect(mapStateToProps, mapDispatchToProps)(Offering);



// WEBPACK FOOTER //
// ./src/components/Offering/index.js